import { Grid2, Box, Typography } from '@mui/material'
import React from 'react'
import { ESCALATION_PRIORITY_LEGENDS, GET_ESCALATION_COLOR } from '../../constants/SeverityColors'
import PiorityDeviationsBackground from '../../assets/priority-highlights.svg';

export default function DeviationRatingLegends() {
    return (
        <Grid2 size={{ lg: 1.25 }} sx={{
            position: 'absolute',
            zIndex: 1,
            top: 'max(8vh, 85px)',
            right: '3.5vw',
            background: `url('${PiorityDeviationsBackground}') no-repeat`,
            backgroundSize: '200%',
            backgroundPosition: 'top right',
            display: 'grid',
            rowGap: 0.75,
            paddingTop: '1vw',
            paddingRight: '1vw'
        }}>
            <Box sx={{
                background: 'var(--text-dark)',
                color: 'var(--text-light)',
                borderTopRightRadius: '0.75vw',
                display: 'grid',
                placeContent: 'center',
                paddingY: '0.25vh',
            }}>
                <Typography variant='subtitle1' textTransform={'capitalize'}>
                    Escalation Priority
                </Typography>
            </Box>
            <Box sx={{
                display: 'grid',
                gridTemplateRows: 'repeat(4, 1fr)',
                rowGap: '0.5vh',
                backdropFilter: 'blur(15px)'
            }}>
                {
                    ESCALATION_PRIORITY_LEGENDS.map((priority, index) => {
                        return <Box key={index}
                            sx={{
                                paddingY: '0.25vh',
                                background: 'var(--text-light)',
                                borderLeft: `0.25vw solid ${GET_ESCALATION_COLOR(priority)}`,
                            }}>
                            <Typography textTransform={'uppercase'} variant='subtitle1' textAlign={'center'}>
                                {priority}
                            </Typography>
                        </Box>
                    })
                }
            </Box>
        </Grid2>
    )
}
